var shipping = {
    // COGS: 0.68,
    msrp: 12.95,
    image: '',
    planId: 'XY-SHIPPING-FULL-2',
    amount: 12.95,
    quantity: 1,
    subtitle: '(Non-US $17.95)',
    name: '$12.95 (price you pay)',
    // value: 12.95,
};
var shippingIntl = {
    // COGS: 2.65,
    // msrp: 17.95,
    image: '',
    planId: 'XY-SHIPPING-INTL-1',
    amount: 17.95,
    quantity: 1,
    subtitle: '(US $12.95)',
    name: '$17.95 (price you pay)',
    // value: 17.95,
};
var primary = {
    // COGS: 1,
    image: 'https://my.coinapp.co/nfc.svg',
    msrp: 50,
    // note: 'Requires NFC compatibility. Not compatible with iPhone 5, 6, 6+ or SE (2016), and some older Android Devices.',
    planId: 'XYO-SENTINEL-NFC-01',
    amount: 0,
    quantity: 1,
    subtitle: '(Normal Price: $50)',
    name: '1 SentinelX NFC Device: Free',
    // shipping,
    // value: 0,
};
var trial = {
    // COGS: 0,
    image: '',
    planId: 'XYO-COIN-PRO-3D-TRIAL-34-95',
    name: 'COIN 3 Day Trial',
    amount: 0,
    quantity: 1,
    removable: true,
    // value: 42,
};
var subscription = {
    // COGS: 0,
    image: '',
    planId: 'XYO-COIN-PRO-34-95',
    name: 'COIN Pro Subscription',
    amount: 34.95,
    quantity: 1,
    // value: 34.95,
};
var upsell = {
    // COGS: 3,
    // image: threePackImage,
    image: '',
    planId: 'XYO-SENTINEL-NFC-3-PACK-01',
    name: '3 SentinelX NFC Devices',
    amount: 67,
    quantity: 1,
    // value: 67,
};
var semiAnnual = {
    // COGS: 0,
    image: '',
    planId: 'COIN-PRO-SEMIANNUAL-PLAN-110-82',
    name: 'COIN Pro Semiannual Subscription',
    amount: 110.82,
    quantity: 1,
    // value: 110.82,
};
export var nfcCartItems = {
    primary: primary,
    shipping: shipping,
    shippingIntl: shippingIntl,
    trial: trial,
    subscription: subscription,
    upsell: upsell,
    semiAnnual: semiAnnual,
};
//# sourceMappingURL=Nfc.js.map